module.exports = __webpack_public_path__ + "static/media/microscope-04.c3c28f71.PNG";